import React, { Component } from 'react'
import {Row, Col, Label, Input} from "reactstrap";
import {observer} from "mobx-react";
import ModalForm from "../../../comum/components/ModalForm";
import ImportacaoDocsImportarStore from "../stores/ImportacaoDocsImportarStore";
import FormSelectSimples from "../../../comum/components/FormSelectSimples";
import FormInputSimples from "../../../comum/components/FormInputSimples";
import FormInputCNPJCPF from "../../../comum/components/FormInputCNPJCPF";
import { IconeDelete } from '../../../comum/components/Icones';

@observer
export class ImportacaoDocsImportar extends Component {
    constructor(props) {
        super(props);

        this.controller = new ImportacaoDocsImportarStore(this.props.service);
        this.controllerDetalhes = this.props.controller;
        this.controllerImportacao = this.props.controllerImportacao;

        this.state = {
            salvado: false            
        }
        
        this.hasCPF = false;
        
        this.setHasCPF = this.setHasCPF.bind(this);
    };

    validar = () => {
        for (let x = 0; x < this.controller.listaArquivos.length; x++) {
            let arquivo = this.controller.listaArquivos[x];
            if (!arquivo.tipoDocId) 
            {
                return false;
            }
            if (!arquivo.numDoc && arquivo.exigeCPF)
            {
                return false;             
            }
            if (arquivo.numDoc && arquivo.exigeCPF)
            {
                if (!((/^[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}$/g).test(arquivo.numDoc) || (/^\-?[0-9]*$/g).test(arquivo.numDoc)) && arquivo.tipoDocId.value !== 12)
                {
                    return false;
                }                
            }
        }
        return true;
    };

    handleAdicionar = () => {
        this.setState({salvado: true});
        if (this.validar()) {
            this.controller.envia(() => this.controllerImportacao.atualizaDocumentos(this.controllerImportacao.linhaDetalhes.BlId, this.controllerImportacao.linhaDetalhes.NumeroBl, this.controllerImportacao.linhaDetalhes.ProtocoloId), () => this.handleFechar());
        }
    };

    handleFechar = () => {
        this.controllerDetalhes.modalCarregarDoc = false;
    };

    setHasCPF = () => {
        this.hasCPF = false;
        if (this.controller.listaArquivos.length>0)
        {
            this.controller.listaArquivos.map((arq, x) => {
                if (arq.tipoDocId && [8,12,14].includes(arq.tipoDocId.value))
                {
                   this.hasCPF = true;
                   arq.exigeCPF = true;
                }
                else
                {
                   arq.exigeCPF = false;
                }
            });
        }
        
        return true;
    }

    montarPlaceHolder = (tipoProcesso) =>
    {
        if (tipoProcesso === 8) 
        {
            return "Número CPF"
        } else if (tipoProcesso === 12) 
        {
            return "Nome do documento"
        } else if (tipoProcesso === 14) 
        {
            return "Número CPF"
        }
    }

    render() {
        const naoSalvar = this.controller.listaArquivos.length===0;
        let xs=12; let sm=4; let md=4; let lg=4; let xl=4;
        let xs2=12; let sm2=4; let md2=4; let lg2=4; let xl2=4;
        return (
            <ModalForm salvando={this.controller.aguardandoSalvar} className="area-form-modal"
                    onClickCancelar={ () => this.controllerDetalhes.modalCarregarDoc = false }
                    labelConfirmar='SALVAR'
                    onClickSalvar={ this.handleAdicionar }
                    esconderSalvar={ naoSalvar } >
                <h2>Novo documento</h2>
                <div className="importacao-detalhes-adiciona-docs">
                    <Row>
                        <Col sm={12} md={12}>
                            <Label>Anexar arquivo</Label>
                            <Input type="file" onChange={e => this.controller.guarda(e, this.controllerImportacao.linhaDetalhes.BlId, this.controllerImportacao.linhaDetalhes.ProtocoloId )} multiple />
                        </Col>
                    </Row>
                    { this.controller.listaArquivos.length>0 &&
                        <Row>
                            <Col className="mb-0" xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
                                <Label className={"nome-arquivo mb-0"}>Arquivo</Label>
                            </Col>
                            <Col className="mb-0" xs={xs2} sm={sm2} md={md2} lg={lg2} xl={xl2}>
                                <Label className={"nome-arquivo mb-0"}>Tipo de documento</Label>
                            </Col>
                            
                            { this.hasCPF &&
                                <Col className="mb-0" xs={xs2} sm={sm2} md={md2} lg={lg2} xl={xl2}>
                                </Col>
                            }
                        </Row> 
                    }
                    { this.controller.listaArquivos.length>0
                        &&  this.controller.listaArquivos.map((arq, x) => (
                            <div key={x} className={"control mb-4"} >
                                <Row>
                                    {!this.controller.excluindo ? 
                                        <FormInputSimples xs={xs} sm={sm} md={md} lg={lg} xl={xl}
                                                        dado={ arq.dscArquivo }
                                                        bloqueado={true}
                                                        onChange={ () => {} } />
                                        :
                                        <div />
                                    }
                                    <FormSelectSimples xs={xs2} sm={sm2} md={md2} lg={lg2} xl={xl2}
                                                       itens={ this.controllerImportacao.tiposDocumento }
                                                       dado={ arq.tipoDocId }
                                                       alerta={ !arq.tipoDocId && this.state.salvado ? "Campo obrigatório" : false }
                                                       onChange={ (event) => {this.controller.setTipo(event, x); this.setHasCPF();} } />
                                    {(!arq.tipoDocId || ![8,12,14].includes(arq.tipoDocId.value)) && arq.exigeCPF &&
                                        <FormInputSimples xs={xs2} sm={sm2} md={md2} lg={3} xl={3}
                                                          hidden={true}
                                        />
                                    }
                                    {arq.tipoDocId && [8,14].includes(arq.tipoDocId.value) &&
                                        <FormInputCNPJCPF xs={xs2} sm={sm2} md={md2} lg={3} xl={3}
                                                          dado={ arq.numDoc }
                                                          alerta={ arq.exigeCPF && !arq.numDoc && this.state.salvado ? "Campo obrigatório" : false }
                                                          bloqueado={false}
                                                          placeholder={this.montarPlaceHolder(arq.tipoDocId.value)}
                                                          onChange={ (event) => this.controller.setNumDoc(event, x) } 
                                        />
                                    }
                                    {arq.tipoDocId && [12].includes(arq.tipoDocId.value) &&
                                        <FormInputSimples xs={xs2} sm={sm2} md={md2} lg={3} xl={3}
                                                          dado={ arq.numDoc }
                                                          alerta={ arq.exigeCPF && !arq.numDoc && this.state.salvado ? "Campo obrigatório" : false }
                                                          bloqueado={false}
                                                          placeholder={this.montarPlaceHolder(arq.tipoDocId.value)}
                                                          onChange={ (event) => this.controller.setNumDoc(event, x) } 
                                        />
                                    }
                                    <IconeDelete className={"icone-delete-borda"} tamanho="3x" onClick={()=> {this.controller.excluirArquivoAnexo(x)}} />
                                </Row>
                                { this.controller.listaMsgs[x] ? <Label className="msg label-danger">{ this.controller.listaMsgs[x] }</Label> : "" }
                            </div>
                        ))
                    }
                </div>
            </ModalForm>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/liberacoes/importacao/components/ImportacaoDocsImportar.js